import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { lazy } from "react";
import ErrorPage from "./page/shell/ErrorPage";
import PageLayout from "./page/layout/PageLayout";
import EntityPage from "./page/pages/EntityPage";
import { recordDefinitions } from "./page/pages/recordDefinitions";
import { listDefinitions } from "./page/lists/listDefinitions";
import { pageDefinitions } from "./page/pages/pageDefinitions";
const ListPage = lazy(() => import("./page/lists/ListPage"));
const PanelPage = lazy(() => import("./page/pages/PanelPage"));
const ManageViews = lazy(() => import("./page/builder/manageViews/manageViews"));
const Home = lazy(() => import("./page/shell/Home"));
const NotFound = lazy(() => import("./page/shell/NotFound"));
const Page = lazy(() => import("./page/shell/IframePage"));
const Report = lazy(() => import("./page/shell/ReportPage"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Home />} />
      <Route errorElement={<ErrorPage />} element={<PageLayout />}>
        <Route
          path="/manage-views/:pagePath/:viewId?"
          element={<ManageViews />}
          handle={{ menu: "closed" }}
        />
        {recordDefinitions.map((definition) => (
          <Route
            key={definition.path}
            path={definition.path}
            element={
              <EntityPage entityName={definition.entityName} />
            }
            handle={
              definition.hideNavigation
                ? { menu: "hidden" }
                : undefined
            }
          />
        ))}
        {listDefinitions.map((definition) => (
          <Route
            key={definition.path}
            path={definition.path}
            element={
              <ListPage
                key={definition.path}
                path={definition.path}
              />
            }
          />
        ))}
        {pageDefinitions.map((definition) => (
          <Route
            key={definition.path}
            path={definition.path}
            element={<PanelPage path={definition.path} />}
          />
        ))}
        <Route path="/page/*" element={<Page />} />
        <Route path="/report/*" element={<Report />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </>
  )
);

function Routing() {
  return <RouterProvider router={router} />;
}
export default Routing;
